import type { SizePalette } from '@theme/theme.d';
import { getSizes, pxToRem } from '@theme/utils/sizing';

export const Sizes: SizePalette = {
  '1.5': pxToRem(1.5),
  ...getSizes({ min: 1, max: 300, steps: 1 }),
};

export const borderSize = {
  xsmall: Sizes[1],
  small: Sizes[2],
  medium: Sizes[4],
  large: Sizes[12],
  xlarge: Sizes[24],
};

export const edgeSize = {
  none: '0px',
  hair: Sizes[1],
  xxxsmall: Sizes[4],
  xxsmall: Sizes[8],
  xsmall: Sizes[12],
  small: Sizes[16],
  medium: Sizes[18],
  large: Sizes[20],
  xlarge: Sizes[24],
  xxlarge: Sizes[32],
  xxxlarge: Sizes[48],
  responsiveBreakpoint: undefined,
};

export const borderRadiusSize = {
  none: '0px',
  small: Sizes[4],
  medium: Sizes[16],
  large: Sizes[21],
  xlarge: Sizes[32],
  full: '100rem',
};

export const imageSize = {
  none: '0px',
  small: Sizes[48],
  medium: Sizes[72],
  large: Sizes[128],
  full: '100%',
};

export const iconSize = {
  xsmall: Sizes[8],
  small: Sizes[12],
  medium: Sizes[24],
  large: Sizes[48],
  xlarge: Sizes[96],
};

export const progressSize = {
  xsmall: '21px',
  small: '30px',
  medium: '48px',
  large: '72px',
  xlarge: '96px',
};

export const thicknessSize = {
  xsmall: Sizes[72],
  small: Sizes[72],
  medium: Sizes[128],
  large: Sizes[192],
  xlarge: Sizes[256],
};

export const size = {};
export const spacing = Sizes[16];
